/**
 * https://github.com/OP-TED/eforms-notice-editor/blob/develop/src/main/resources/static/js/custom/global.js
 */
export const EformsConstants = {
  DEBUG: true,

  DATA_EDITOR_ID_REFERENCE: 'data-editor-id-reference',
  DATA_EDITOR_ID_REF_PREFIX: 'data-editor-id-ref-',
  DATA_EDITOR_ID_SCHEME: 'data-id-scheme',

  INTERNAL: '_internal_',

  EDITOR_ID_PREFIX: 'editor-id-',

  BR_DK_BUYER_NOT_WHITELISTED: 'BR-DK-BUYER-NOT-WHITELISTED',

  Attributes: {
    CONTENT_ID_ATTRIBUTE: 'data-content-id',
    CONTENT_TYPE_ATTRIBUTE: 'data-content-type',
    NODE_ID_ATTRIBUTE: 'data-node-id',
    ID_SCHEME_ATTRIBUTE: 'data-id-scheme',
    ID_SCHEMES_ATTRIBUTE: 'data-id-schemes',
    VALUE_SOURCE_ATTRIBUTE: 'data-value-source',
    COUNTER_ATTRIBUTE: 'data-counter'
  },

  HtmlElements: {
    FORM_ELEMENT: 'form-element',
    FORM_CONTENT_ROOT_ELEMENT: 'form-content-root',
    APP_VERSION_ELEMENT: 'app-version'
  },

  ChoiceNodes: {
    INTERNAL_CHOICE: '_internal_choice-',
    get ROOT() { return this.INTERNAL_CHOICE + 'root'; },
    get PARENT() { return this.INTERNAL_CHOICE + 'parent-'; },
    get LEAF() { return this.INTERNAL_CHOICE + 'leaf-'; }
  },

  ContentType: {
    FIELD: 'field',
    GROUP: 'group',
    DATA_CONTAINER: 'notice-data',
    METADATA_CONTAINER: 'notice-metadata',
    ROOT: 'notice'
  },

  VisType: {
    CONTENT_COUNT: 'contentCount',
    VALUE: 'value',
    TYPE: 'visType',
    FIELD: 'field',
    NON_FIELD: 'non-field',
  },

  StandardAffix: {
    LOT: 'lot',
    PART: 'part'
  },

  StandardIdentifiers: {
    NOTICE_ROOT: 'notice-root',
    NOTICE_METADATA: 'notice-metadata',
    ND_ROOT: 'ND-Root',
    SDK_VERSION_FIELD: 'OPT-002-notice',
    UBL_VERSION_FIELD: 'OPT-001-notice',
    NOTICE_SUBTYPE_FIELD: 'OPP-070-notice',
    NOTICE_UUID_FIELD: 'BT-701-notice',
    NOTICE_VERSION_FIELD: 'BT-757-notice',
    NOTICE_PUBLICATION_NUMBER: 'OPP-010'
  },

  GroupIdentifiers: {
    GR_LOT: 'GR-Lot',
    GR_PART: 'GR-Part',
    ORG: 'GR-Organisations',
    CHANGE: 'GR-Change',
    ROLE_BUYER: 'MU-GR-Organisation-Role-Buyer',
    CONTRACT_AUTH: 'GR-ContractingAuthority',
    TOUCH_POINT: 'GR-Touch-Point'
  },

  BypassSkalFeltVisesWrapper: [
    'OPT-300-Procedure-SProvider'
  ],

  Languages: {
    get DEFAULT() { return this.DANISH },
    DANISH: 'DAN',
    ENGLISH: 'ENG'
  },

  Regex: {
    MATCH_BTID_SUFFIX_COUNT: /-\d+$/
  }
};
